module.exports = __webpack_public_path__ + "static/media/biometrico.d7a64605.svg";